import React from 'react';
import '../../App.css';
import './MainHeroSection.css';

function HeroSection() {
  return (
    <div className='hero-wrap'>
      <video className='hero-video' autoPlay loop muted playsInline preload="auto" poster="/videos/hero-poster.jpg">
        <source src='/videos/car-detailing.mp4' type='video/mp4' />
      </video>

      <div className='hero-container'>
        <div className='hero-content detailing'>
          <p className="subtitle">FULL SERVICE AND EXCELLENT QUALITY</p>
          <h1>CAR DETAILING</h1>
          <div className="scroll-indicator">SCROLL DOWN ↓</div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;